import SearchBoxPlace from './SearchBoxPlace';
export default SearchBoxPlace;
